import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.hr<{ dashed?: boolean; page?: boolean }>(
    props => ({
        height: 1,
        border: "none",
        backgroundColor: theme(props).border.color,
    }),
    props =>
        props.dashed && {
            backgroundColor: "transparent",
            backgroundImage: `linear-gradient(90deg, ${theme(props).border.color}, ${
                theme(props).border.color
            } 50%, transparent 50%, transparent 100%)`,
            backgroundSize: `10px 1px`,
        },
    props =>
        props.page && {
            margin: `0 -40px`,
        }
);
